import { render, staticRenderFns } from "./EditProfileForm.vue?vue&type=template&id=5f4d4085&"
import script from "./EditProfileForm.vue?vue&type=script&lang=js&"
export * from "./EditProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports